import React from 'react';
import { EuiConfirmModal, EUI_MODAL_CONFIRM_BUTTON, EuiLink, EuiText } from '@elastic/eui';

export interface SunsetModalProps {
  onClose: () => void;
}

export function SunsetModal({ onClose }: SunsetModalProps) {
  return (
    <EuiConfirmModal
      title="We've moved!"
      onCancel={onClose}
      onConfirm={() => (location.href = 'https://etfvue.com')}
      cancelButtonText="Close"
      confirmButtonText="Go to etfvue.com"
      defaultFocusedButton={EUI_MODAL_CONFIRM_BUTTON}
      buttonColor="primary"
    >
      <p>
        <strong>AZbyte.xyz</strong> has moved to a new home – you can now access the most up-to-date ETF data at
      </p>
      <p>
        <EuiText textAlign={'center'} style={{ fontSize: '160%' }}>
          <EuiLink href="https://etfvue.com">
            <strong>etfvue.com</strong>
          </EuiLink>
        </EuiText>
      </p>
      <p>
        This site will no longer receive updates and is scheduled to be sunset on <strong>August 1, 2025</strong>. If
        you have portfolios saved on <strong>AZbyte.xyz</strong>, you can manually export and import them at the new
        website anytime before August.
      </p>
      <p>
        If you need any help with the migration process, feel free to reach out at{' '}
        <EuiLink href={'mailto:contact@etfvue.com'}>contact@etfvue.com</EuiLink>.
      </p>
      <p>
        Thanks for using <strong>AZbyte.xyz</strong> – your support is appreciated, and I hope you'll find even more
        value at{' '}
        <EuiLink href="https://etfvue.com">
          <strong>etfvue.com</strong>
        </EuiLink>
        .
      </p>
    </EuiConfirmModal>
  );
}
